export const APP_NAME = "Corian Park";
export const DOMAIN = "corianpark.au";
export const SITE_URL = "https://corianpark.au";
export const API_URL = "https://api.corianpark.au";
export const SOURCE_PLATFORMS = ["YOUTUBE", "RSS", "REDDIT", "TRACTRS", "MANUAL"];
export const SOURCE_TYPES = [
    "YOUTUBE_CHANNEL",
    "YOUTUBE_SEARCH",
    "RSS",
    "REDDIT_SUBREDDIT",
    "TRACTRS_NEWS",
    "TRACTRS_RELEASES",
    "TRACTRS_NEWS_PUBLIC",
];
export const CONTENT_TYPES = ["VIDEO", "ARTICLE", "DIRT_TALK", "RIG_FEATURE"];
export const CONTENT_STATUSES = [
    "PENDING",
    "APPROVED",
    "REJECTED",
    "PUBLISHED",
    "AUTO_PUBLISHED",
];
export const DIRT_TALK_VARIANTS = [
    "MACHINE_OF_DAY",
    "DID_YOU_KNOW",
    "THIS_DAY_IN_DIRT",
];
export const DIRT_TALK_STATUSES = ["PENDING", "APPROVED", "AUTO_PUBLISHED"];
export const RIG_OF_WEEK_STATUSES = [
    "CANDIDATES_READY",
    "APPROVED",
    "PUBLISHED",
    "AUTO_PUBLISHED",
];
export const QUOTE_REQUEST_STATUSES = [
    "NEW",
    "ASSIGNED",
    "CONTACTED",
    "WON",
    "LOST",
];
export const USER_ROLES = ["ADMIN", "DREW", "OPERATOR", "PUBLIC"];
export const ACCOUNT_TYPES = ["INDIVIDUAL", "COMPANY"];
// Categories of things a signed-in user can drop into their Loader Bucket.
// Mirrored on the backend for SavedItem.itemType.
export const SAVED_ITEM_TYPES = [
    "video", // ContentItem with type=VIDEO
    "article", // ContentItem with type=ARTICLE
    "post", // SocialPost
    "rig", // RigOfWeek
    "dirttalk", // DirtTalk
];
export const SOURCE_RUN_STATUSES = ["PENDING", "RUNNING", "SUCCESS", "ERROR"];
export const PROJECT_TYPES = [
    "site_cut",
    "dam_construction",
    "earthworks_residential",
    "earthworks_commercial",
    "mining_subcontract",
    "civil_infrastructure",
    "land_clearing",
    "demolition",
    "other",
];
export const ADMIN_SETTING_KEYS = [
    "notificationRecipients",
    "dirtTalkAutoPublishCutoffUtc",
    "rigOfWeekAutoPublishCutoffUtc",
];
//# sourceMappingURL=index.js.map